import { EmptyStateSecondaryAction } from '@synoptic/ui-kit/empty-state/empty-state-secondary-action.js';
import { LinkButton } from '@synoptic/ui-kit/link-button/link-button.js';
import { showIntercomMessages } from '@/intercom';
import {
  emergencyContactUsContainer,
  emergencyContactUsFooter,
} from './emergency-contact-us.css';

export const EmergencyContactUs = () => {
  return (
    <div className={emergencyContactUsContainer}>
      <EmptyStateSecondaryAction
        variant="secondary"
        onClick={showIntercomMessages}
      >
        Open Support Chat
      </EmptyStateSecondaryAction>

      <div className={emergencyContactUsFooter}>
        Chat not opening?
        <br />
        Email us at{' '}
        <LinkButton asChild size="medium">
          <a href="mailto:info@synoptic.com">info@synoptic.com</a>
        </LinkButton>
      </div>
    </div>
  );
};
